function toPrimitive(i: unknown) {
  const type = typeof i === 'string' || typeof i === 'number'
  return type ? i : undefined
}

export function myInputValue<T>(e: Event | undefined, pipe: (e: string | number | undefined) => T): T {
  const t = e?.target
  return pipe(t && 'value' in t ? toPrimitive(t.value) : undefined)
}
